import Repository from '../axios'
import {defaultPagination} from "@/constants/config";
import staff from "../apis/staff";

const  resource = "/admin/staff";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getStaff(staffId){
    return Repository.get(`${resource}/${staffId}`)
  },
  createStaff(payload){
    return Repository.post(`${resource}`, payload)
  },
  updateStaff(staff_id, payload){
    return Repository.put(`${resource}/${staff_id}`, payload)
  },
  accountVerify(code) {
    return Repository.get(`/admin/verify/${code}`)
  },
  forgotPassword(payload) {
    return Repository.post(`/landlord/forgot-password`, payload)
  },
  getForgotPasswordToken(token){
    return Repository.get(`/landlord/forgot-password/${token}`)
  },
  passwordReset(payload){
    return Repository.post(`/landlord/reset-password`, payload)
  },
  passwordChange(payload){
    return Repository.put(`/user/change-password`, payload)
  },
  getCurrencyList(){
    return Repository.get(`admin/currencies`)
  },
  resendWelcomeEmail(email) {
    return Repository.put(`/admin/${email}/staff-resend`)
  },

  // 2fa
  get2FAQRCode(staff_id) {
    return Repository.get(`/admin/2fa/${staff_id}/show-2fa-code`)
  },
  enable2FA(payload, staff_id) {
    return Repository.put(`/admin/2fa/${staff_id}/enable-2fa`, payload)
  },
  disable2FA(payload, staff_id) {
    return Repository.put(`/admin/2fa/${staff_id}/disable-2fa`, payload)
  },

  uploadProfileImage(auth_id, payload) {
    return Repository.put(`/admin/${auth_id}/staff-avatar`, payload)
  },
};
